<template>
	<el-dialog :visible.sync="dialogVisible" width="700px" :append-to-body="true" v-loading="loading">
		<template slot="title">
			<div class="title-header">
				<div class="history-title">
					<span>{{ $t("detailContact.chatInformation") }}</span>
				</div>
				<div v-if="metisBot.usage_limit">
					<span style="font-size: 12px; color: #606266"
						>{{ $t("detailContact.METISusageCount") }}{{ metisBot.usage_limit }}，{{ $t("detailContact.leftOver") }}{{ metisBot.remaining_count
						}}{{ $t("detailContact.strip") }}</span
					>
				</div>
			</div>
		</template>
		<section class="message-content">
			<el-form label-width="165px" label-position="left" style="word-break: normal">
				<el-form-item :label="$t('detailContact.nickName')">
					<span class="form-text" :title="nickName">{{ nickName }}</span>
				</el-form-item>
				<el-form-item :label="$t('detailContact.phoneNumber')">
					<span class="form-text" :title="phoneNumber">{{ phoneNumber }}</span>
				</el-form-item>
				<el-form-item :label="$t('detailContact.remarkName')" style="height: 55px">
					<el-row type="flex" :gutter="5">
						<el-col :span="16">
							<span class="form-text" :title="note">{{ note }}</span>
						</el-col>
						<el-col :span="8">
							<el-button size="mini" @click="changeNote()">{{ $t("detailContact.revise") }}</el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item :label="$t('detailContact.associatedCustomers')">
					<span class="form-text" v-if="customers.length === 0">{{ $t("detailContact.none") }}</span>
					<ul class="customers">
						<li v-for="customer in customers" v-bind:key="customer.customer_id">
							<el-tag size="mini">{{ customer.customer_id | removeFrontZero }}</el-tag>
							{{ customer.customer_name }}
						</li>
					</ul>
				</el-form-item>
				<template v-for="bot in bots">
					<el-form-item :label="bot.title" :key="bot.id">
						<el-radio-group v-model="bot.status" @input="handleBotsStatus(bot)">
							<el-radio :label="1">{{ $t("detailContact.open") }}</el-radio>
							<el-radio :label="0">{{ $t("detailContact.close") }}</el-radio>
						</el-radio-group>
					</el-form-item>
					<div class="bot-desc" :key="'desc-' + bot.id">{{ bot.description }}</div>
				</template>
				<el-form-item :label="$t('detailContact.automaticTranslation')">
					<el-radio-group v-model="autoTranslatedStatus" @input="handleTranslatedStatus">
						<el-radio :label="1">{{ $t("detailContact.yes") }}</el-radio>
						<el-radio :label="0">{{ $t("detailContact.no") }}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
		</section>
	</el-dialog>
</template>

<script>
import { updateNote } from "@/services/api/api";
import { putBotsStatus, putAutoTranslateStatus, getContactDetail } from "@/services/api-v2/api-v2";

export default {
	name: "DetailContact",

	props: {
		conversation: {
			type: Object,
			required: false,
			default: null,
		},
	},

	data() {
		return {
			dialogVisible: false,

			nickName: "",

			note: "",

			customers: [],

			bots: [],

			loading: false,

			autoTranslatedStatus: 0,
			phoneNumber: "",
		};
	},

	computed: {
		metisBot() {
			return _.find(this.bots, { name: "METIS" }) || {};
		},
	},

	methods: {
		// 打开
		async open() {
			this.getContactDetail(this.conversation.object_id);
		},

		async getContactDetail(userId) {
			try {
				this.dialogVisible = true;
				const { data } = await getContactDetail(userId);
				this.nickName = data.user.nick_name;
				this.note = data.note ? data.note.note : null;
				this.customers = data.customers;
				this.bots = data.bots || [];
				this.autoTranslatedStatus = data.auto_translate;
				this.phoneNumber = data.user.phone_number;
			} catch (e) {
				this.dialogVisible = false;
				this.loading = false;
				this.$message({ message: this.$t("detailContact.userDoesNotBelong"), type: "warning" });
			}
		},

		// Bots AI开关状态变更
		async handleBotsStatus(bot) {
			const previousStatus = this.conversation.bots.find((b) => b.id === bot.id)?.status;
			this.loading = true;
			try {
				await putBotsStatus(this.conversation.object_id, bot.id, bot.status);
				this.$emit("handle-conversations");
				this.$message({ message: this.$t("detailContact.setupSuccessful"), type: "success" });
			} catch (error) {
				bot.status = previousStatus;
				this.$message({ message: error, type: "error" });
			} finally {
				this.loading = false;
			}
		},

		// 自动翻译打开关闭
		async handleTranslatedStatus() {
			this.loading = true;
			try {
				await putAutoTranslateStatus(this.conversation.id, this.autoTranslatedStatus);
				this.$emit("handle-conversations");
				this.$message({ message: this.$t("detailContact.setupSuccessful"), type: "success" });
			} catch (error) {
				this.autoTranslatedStatus = this.conversation.auto_translate;
				this.$message({ message: error, type: "error" });
			} finally {
				this.loading = false;
			}
		},

		// 修改备注
		async changeNote() {
			const { value } = await this.$prompt(this.$t("detailContact.enterRemarks"), this.$t("detailContact.hint"), {
				confirmButtonText: this.$t("common.sure"),
				cancelButtonText: this.$t("common.cancel"),
				inputValue: this.note,
				closeOnClickModal: false,
			});

			this.updateNote(value);
		},

		// 更新备注
		async updateNote(note) {
			try {
				const result = await updateNote(this.conversation.object_id, note);

				this.note = note;

				this.conversation.note = note;

				this.$message({ message: result.message, type: "success" });
			} catch (error) {
				this.$message({ message: error, type: "error" });
			}
		},
	},
};
</script>

<style lang="less" scoped>
.customers {
	list-style: none;
	padding-left: 0px;
	line-height: 30px;
}
.form-text {
	display: inline-block;
	width: 80%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.el-form-item {
	margin-bottom: 10px !important;
}
.message-content {
	height: 500px;
	overflow-y: auto;
	overflow-x: hidden;
	.bot-desc {
		margin-bottom: 10px;
		padding-left: 165px;
		font-size: 12px;
		color: #909399;
	}
}
.title-header {
	display: flex;
	justify-content: space-between;
	margin-right: 40px;
}
</style>
